import React from "react";
import ReactModal from "react-modal";
import PropTypes from "prop-types"

const delay = 300
const initialStyle = {
  content: {
    transformOrigin: "left top",
    transition: `left ${delay}ms, top ${delay}ms, transform ${delay}ms linear`,
  },
  overlay: {
    zIndex: "1101",
  }
}

class OpenOrderNameModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      name: "",
      isCollapsing: false
    }
    this.onCancel = () => {
      this.props.onCancel()
      this.setState({name: ""})
    }
    this.onChange = e => this.setState({name: e.target.value})
    this.onConfirm = () => this.props.onConfirm(this.state.name)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isOpen && !nextProps.isOpen) {
      this.setState({isCollapsing: true})
      setTimeout(this_ => this_.setState({name: "", isCollapsing: false}), delay, this)
    }
  }

  render () {
    let style = initialStyle
    if (this.state.isCollapsing) {
      const rect = this.props.targetRef.getBoundingClientRect()
      style = {
        content: {...initialStyle.content, left: rect.left, top: rect.top, transform: "scale(0.2)"},
        overlay: initialStyle.overlay
      }
    }
    return (
      <ReactModal isOpen={this.props.isOpen || this.state.isCollapsing} style={style}
        className="open-order-name-modal"
        onRequestClose={this.onCancel} contentLabel="Open Order Name Modal">
        <textarea onChange={this.onChange} placeholder="Name" rows="2" value={this.state.name} />
        <button className="save" disabled={!this.state.name} onClick={this.onConfirm}>Save</button>
        <button className="cancel" onClick={this.onCancel}>Cancel</button>
      </ReactModal>
    )
  }
}

OpenOrderNameModal.propTypes = {
  isOpen: PropTypes.bool,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
}

export default OpenOrderNameModal
